import { atom, getDefaultStore, useAtom } from 'jotai';
import { IScreeningTakerModuleStore } from 'Core_Pages/Screening/IScreeningTakerModuleStore';
import { questions } from './Form/config';

export class AdultHOSScreeningModuleStore implements IScreeningTakerModuleStore {
  private atomStore = getDefaultStore();
  private answersAtom;
  private formValidAtom;
  private loadingAtom;
  private completeCallback: (answers) => Promise<void>;

  constructor() {
    this.answersAtom = atom(this.createDefaultAnswers());
    this.formValidAtom = atom(false);
    this.loadingAtom = atom(false);
  }

  private get Answers(): { [key: string]: string | null } {
    return this.atomStore.get(this.answersAtom);
  }

  public get IsValid(): boolean {
    return this.atomStore.get(this.formValidAtom);
  }

  public get IsLoading(): boolean {
    return this.atomStore.get(this.loadingAtom);
  }

  private set IsLoading(isLoading: boolean) {
    this.atomStore.set(this.loadingAtom, isLoading);
  }

  private createDefaultAnswers() {
    const defaultQuestions = {};
    questions.map((x) => (defaultQuestions[x.name] = undefined));
    return defaultQuestions;
  }

  public Use = () => {
    useAtom(this.answersAtom);
    useAtom(this.formValidAtom);
    useAtom(this.loadingAtom);

    return this;
  };

  create(completeCallback: (answers) => Promise<void>): this {
    this.completeCallback = completeCallback;
    return this;
  }

  updateAnswer(question, answer) {
    const currentAnswers = this.atomStore.get(this.answersAtom);
    currentAnswers[question] = answer;

    if (question === 'a945d8f7-ade3-428e-aa9d-b9f33e28d5fc') {
      const answerOptionValue = { answerOptionGuid: '', value: null };
      answerOptionValue.answerOptionGuid =
        answer > 0 ? 'afc3ab7a-568d-487e-944e-b65c7b25b782' : 'd5b55645-b6fc-4238-9ac8-ff2e908e2eee';
      answerOptionValue.value = answer;
      currentAnswers[question] = answerOptionValue;
    } else if (question === '4b250edf-b739-4a55-80cb-ed1bbd0c6b3c') {
      const answerOptionValue = { answerOptionGuid: '', value: null };
      answerOptionValue.answerOptionGuid =
        answer > 0 ? 'f1e8654b-0a3b-4c03-be53-b549e50ef420' : '03c36ccb-2441-4f27-a8f7-1819e22006a1';
      answerOptionValue.value = answer;
      currentAnswers[question] = answerOptionValue;
    }

    this.atomStore.set(this.answersAtom, currentAnswers);
    this.validate();
  }

  validate() {
    const missingAnswers = Object.keys(this.Answers).filter((x) => !this.Answers[x]);
    let skippedCount = 0;
    if (missingAnswers.includes('ba6297bd-7214-48c9-ade0-bf773f5f8b9e')) {
      skippedCount++;
    }
    if (missingAnswers.includes('63c084fd-4fae-466a-b8fa-97c3e256afe6')) {
      skippedCount++;
    }
    const isValid = missingAnswers.length - skippedCount === 0;
    this.atomStore.set(this.formValidAtom, isValid);
  }

  async complete() {
    this.IsLoading = true;

    this.validate();

    if (this.IsValid) {
      const answers = Object.keys(this.Answers).map((x) => this.Answers[x]);
      const formattedAnswers = answers
        .flat()
        .map((r) => {
          if (typeof r == 'string') {
            return { answerOptionGuid: r };
          } else return r;
        })
        .filter((x) => x);

      this.completeCallback(formattedAnswers).then(() => (this.IsLoading = false));
    } else {
      this.IsLoading = false;
    }
  }
}
